export const SCAN_UPLOAD = 'scanUpload'
